import React, {Component} from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField} from "@material-ui/core";
import {AttachFile, Send} from "@material-ui/icons";
import localization from "../../../config/localization";
import MaterialSelection from "../MaterialSelection";
import {setStatePromise} from "../../../utils";
import {ThreadContext} from ".";
import styled from "styled-components";
import InputAdornment from "@material-ui/core/InputAdornment";
import EmojiPicker from "../../../components/Letflow/EmojiPicker";
import { ThemeProvider } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core/styles";

const customTheme = createMuiTheme({
  overrides: {
    MuiInput: {
      input: {
        backgroundColor: "#f1f1f1",
        '&::placeholder': {
          textOverflow: 'ellipsis !important',
          color: 'rgba(0, 0, 0, 0.08)'
        } // if you also want to change the color of the input, this is the prop you'd use
      }
    },
  }
});


const styles = {
  'input': {
    backgroundColor: "#f1f1f1",
    '&::placeholder': {
      textOverflow: 'ellipsis !important',
      color: 'rgba(0, 0, 0, 0.08)'
    }
  }
};

class MessageSendInput extends Component {
  constructor() {
    super();
    this.state = {
      showDialog: false,
      message: "",
      selectedEmoji: null,
      cursorPosition: 0,
    };
  }

  onSendWrapper = () => {
    this.props.onSend(this.state.message);
    this.setState({ message: "" });
  };

  onKeyDown = e => {
    const enterPressed = e.key === "Enter";
    const shiftNotPressed = !e.shiftKey;

    if (enterPressed && shiftNotPressed) {
      e.preventDefault();
      this.onSendWrapper();
    }
  };

  render = () => {
    const { onSendMaterial } = this.props;
    const { showDialog, message } = this.state;

    return (
      <ThreadContext.Consumer>
        {({ pitch }) => {
          const userDoesNotBelongToConversation = !pitch.user_belongs_to_pitch;
          return (
            <div style={{ display: "flex", padding: "2.5px 0", flexWrap: "wrap", backgroundColor: "#b2b1b1"}}>
              {/** Message Input Field with Send Material Button */}
              <SendMaterialDialog
                open={showDialog}
                message={this.state.message}
                onCancel={() => this.setState({ showDialog: false })}
                onSendMaterial={(material, onProgress) =>
                  onSendMaterial(material, onProgress)
                    .then(() => this.setState({ showDialog: false, message: "" }))
                }
              />
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-end"
                }}
              >
                <IconButton>
                  <EmojiPicker
                    onEmojiSelect={event => {
                      const output = [this.state.message.slice(0, this.textareaRef.selectionStart), event.emoji, this.state.message.slice(this.textareaRef.selectionStart)].join('');
                      this.textareaRef.focus();
                      this.setState({ message: output })
                    }}
                  />
                </IconButton>
                <IconButton
                  onClick={() => this.setState({ showDialog: true })}
                  disabled={
                    this.props.disabled || userDoesNotBelongToConversation
                  }>
                  <AttachFile style={{fontSize: "1.2rem"}} />
                </IconButton>
              </div>
              <DivR>
                <ThemeProvider theme={customTheme}>
                  <InputMessage
                    ref={r => this.textareaRef = r}
                    value={message}
                    onChange={e => this.setState({ message: e.target.value })}
                    onKeyDown={this.onKeyDown}
                    placeholder={localization.get("pitch.write_new_message")}
                    disabled={this.props.disabled || userDoesNotBelongToConversation}
                  />
                  {/*<TextField
                    ref={r => this.textareaRef = r}
                    value={message}
                    onChange={e => this.setState({ message: e.target.value })}
                    onKeyDown={this.onKeyDown}
                    placeholder={localization.get("pitch.write_new_message")}
                    disabled={this.props.disabled || userDoesNotBelongToConversation}
                    multiline
                    fullWidth
                    style={{
                      alignItems: "center",
                      padding: 10,
                      '&::p:first-child': {
                        backgroundColor: "#f1f1f1",
                      }
                  }}
                  />*/}
                </ThemeProvider>
              </DivR>
                {/** Send Message Button */}
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <IconButton
                  onClick={this.onSendWrapper}
                  disabled={message.length === 0 || this.props.disabled || userDoesNotBelongToConversation}
                >
                  <Send />
                </IconButton>
              </div>
            </div>
          );
        }}
      </ThreadContext.Consumer>
    );
  };
}

class SendMaterialDialog extends Component {
  state = {
    sending: false,
    showProgress: false,
    progress: 0,
    message: ""
  };

  componentWillReceiveProps(nextProps, nextContext) {
    if(nextProps.open !== this.props.open && nextProps.message) {
      this.setState({message: nextProps.message})
    }
  }

  onSubmit = () =>
    setStatePromise(this, { sending: true, progress: 0 })
      .then(() =>
        this.props.onSendMaterial(
          { ...this.materialSelection, message: this.state.message },
          (cur, tot) =>
            this.setState({ progress: Math.floor((cur / tot) * 100) })
        )
      )
      .finally(() =>
        setStatePromise(this, {
          sending: false,
          message: "",
          showProgress: false,
          progress: 0
        })
      );

  onCancel = () => {
    this.setState({ message: "" }, () => {
      this.props.onCancel();
    });
  };

  render = () => {
    const { open } = this.props;

    const { sending, message } = this.state;

    return (
      <Dialog open={open}>
        <DialogTitle>
          {localization.get("pitch.upload_media_title")}
        </DialogTitle>
        <DialogContent>
          {open && (
            <React.Fragment>
              <TextField
                style={{ marginBottom: 20 }}
                value={message}
                label={localization.get("pitches.optional_message")}
                onChange={e => this.setState({ message: e.target.value })}
                fullWidth
              />
              <MaterialSelection onChange={materialSelection => this.materialSelection = materialSelection} />
            </React.Fragment>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={this.onCancel} disabled={sending}>
            {localization.get("cancel")}
          </Button>
          <Button onClick={this.onSubmit} disabled={sending}>
            {sending ? this.state.progress + "%" : localization.get("send")}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
}

export default MessageSendInput;

const DivR = styled.div`
  flex: 15;
  white-space: nowrap;
  overflow:hidden;
  text-overflow: ellipsis;
@media (max-width: 470px) {
   margin-left: 5px;
}
`;

const InputMessage= styled.textarea`
  margin-top: 5px;
  padding: 13px 10px 10px;
  width: 100%!important;
  height: 44px;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.3);
  border-color: rgba(0, 0, 0, 0);
  resize: none;
  ::-webkit-input-placeholder {
    color: white!important;
  }

  :-moz-placeholder { /* Firefox 18- */
    color: white!important;
  }

  ::-moz-placeholder {  /* Firefox 19+ */
    color: #0bf;
  }

  :-ms-input-placeholder {
    color: #0bf;
  }

  textarea::placeholder {
    color: #0bf;
  }
`


